import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FieldErrorDisplayModule } from '../field-error-display';
import { ActivitiesModule } from '@web-frontend/core/admin/activities/activities.module';
import { BudgetsModule } from '@web-frontend/core/admin/budgets/budgets.module';
import { MatTabsModule } from '@angular/material/tabs';
import { MatMenuModule } from '@angular/material/menu';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AddressMapModule } from '../address-map/address-map.module';

import { ClickDeleteModule } from '@web-frontend/shared/directives/click-delete';
import { RmSelectV2Module } from '../globals/rm-select-v2';
import { TooltipModule } from '@web-frontend/shared/directives/tooltip/tooltip.module';
import { ObligatoryFieldSignModule } from '../obligatory-field-sign/obligatory-field-sign.module';
import { ModalTemplateModule } from '../modal-template';
import { BaseButtonModule } from '@web-frontend/common/components/button/baseButton.module';
import { UpdateCompanyDataComponent } from './update-company-data.component';
import { GooglePlacesModule } from '@web-frontend/shared/directives/google-places/google-places.module';

@NgModule({
  declarations: [UpdateCompanyDataComponent],
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    MatFormFieldModule,
    MatInputModule,
    MatTabsModule,
    MatMenuModule,
    MatCheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    FieldErrorDisplayModule,
    ActivitiesModule,
    BudgetsModule,
    AddressMapModule,
    ClickDeleteModule,
    RmSelectV2Module,
    TooltipModule,
    ObligatoryFieldSignModule,
    ModalTemplateModule,
    BaseButtonModule,
    GooglePlacesModule,
  ],
})
export class UpdateCompanyDataModule {}
